<template>
  <landing-page>
    <template #heading>
      The best royalty free music for creators
    </template>
    <template #tagline>
      <template v-if="trialMode">
        Royalty free music &amp; SFX from real artists &mdash; at an unbeatable price. Start a 30-day free trial today.
      </template>
      <template v-else>
        Royalty free music &amp; SFX from real artists &mdash; at an unbeatable price.
      </template>
    </template>

    <template #section-1-heading>
      The best royalty free music you can find
    </template>
    <template #section-1-text>
      Don't settle for stock. Each of our 3 plans give you unlimited access to download and use quality royalty free music &amp; SFX from real artists, and keeps the process simple &mdash; all at an unbeatable price.
    </template>

    <template #section-2-heading>
      Committed to quality music
    </template>
  </landing-page>
</template>

<script>
import LandingPage from '@/components/LandingPage.vue'

export default {
  name: 'LandingPageBestMusic',

  components: {
    LandingPage
  },

  computed: {
    trialMode: function () {
      return this.$store.getters['subscriptions/createSubscriptionWithTrial']
    }
  }
}
</script>
